<template>
    <div class="map-container-height">
        <!--Will Not Toggle Properly if put into a class...Leave inline-->
        <div @dblclick="zoomIn" @contextmenu="zoomOut" style="width: 100%; height: 100%;" id='wmap'></div>
        <edit-pin :show-dialog="editTaskDialog" :toggle="toggleEditTask" :job-task="selected ? selected : emptyTask" :open-detail="openDetail"></edit-pin>
        <task-details  :toggle="toggleDetailsTask" :show-dialog="detailsTaskDialog"></task-details>
    </div>
</template>

<script>
    import mapboxgl from 'mapbox-gl';
    import {mapActions, mapGetters} from 'vuex'
    import TaskDetails from '../../../components/jobTasks/Details'
    import EditPin from '../../../components/jobTasks/EditPin'
    import mapHelpers from '../../../utils/helpers/mapHelpers'

    export default {
        name: 'worker-map-view',
        data() {
            return {
                accessToken: 'pk.eyJ1IjoiaG9za2luc3QiLCJhIjoiY2s5M2N6NHprMDEwNDNkbWJieThzbm1hNiJ9.0F7I8B6DKLxTzAXg1oN9Hw',
                mapStyle: 'mapbox://styles/mapbox/outdoors-v12',
                coordinates: [-122.9110,49.2057],
                editTaskDialog: false,
                currentMarkers: [],
                jobTaskToEdit: {},
                detailsTaskDialog: false,
                clickCounter: 0,
                emptyTask: { //prevent console errors by passing this to the edit pin dialog when the selected task is null
                    taskType: '',
                    address: '',
                    notes: '',
                    longitude: -122.9110,
                    latitude:  49.2057
                }
            }
        },
        mounted() {
            this.createMap();
        },
        components: {
            EditPin,
            TaskDetails
        },
        methods: {
            ...mapActions({
                select: 'jobTasks/getById',
                clearSelectedTask: 'jobTasks/clearSelected'
            }),
            createMap() {
                mapboxgl.accessToken = this.accessToken
                // init the map
                this.map = new mapboxgl.Map({
                    container: 'wmap',
                    style: this.mapStyle,
                    minzoom: 1.3,
                    center: this.coordinates,
                    zoom: 10
                })
                this.map.on('load', () => {
                    this.map.resize();
                });
                this.map['doubleClickZoom'].disable()
                this.map.addControl(new mapboxgl.NavigationControl());
                this.map.addControl(
                    new mapboxgl.GeolocateControl({
                        positionOptions: {
                            enableHighAccuracy: true
                        },
                        showAccuracyCircle: false,
                        trackUserLocation: true
                    })
                );
                this.addMarkers()

            },
            zoomIn() {
                let z = this.map.getZoom()
                this.map.flyTo({ zoom: z + 2, speed: 0.2, curve: 1, essential: true })
            },
            zoomOut (e) {
                e.preventDefault()
                this.clickCounter++
                if (this.clickCounter === 2) {
                    let z = this.map.getZoom()
                    this.map.flyTo({ zoom: z - 2, speed: 0.2, curve: 1, essential: true })
                    this.clickCounter = 0
                }
            },
            selectTask (task) {
                this.select(task.id)
                this.toggleEditTask()
            },
            addMarkers() {
                this.currentMarkers.forEach(marker => { marker.remove() })
                this.currentMarkers = []
                this.mapTaskArray.forEach(task => {
                    if(!task){
                        return
                    }
                    let marker
                    const markerType = mapHelpers.parseType(task)
                    if (this.selected) {
                        if (task.id === this.selected.id && this.selected) {
                            marker = new mapboxgl.Marker({ element: mapHelpers.getSelectedElement() })
                        } else {
                            marker = new mapboxgl.Marker({
                                element: mapHelpers.getElement(markerType)
                            })
                        }
                    } else {
                        marker = new mapboxgl.Marker({
                            element: mapHelpers.getElement(markerType)
                        })
                    }
                    marker.setLngLat([task.longitude, task.latitude])
                        .addTo(this.map)
                    marker.getElement().addEventListener('click', () => {
                        this.selectTask(task);
                    });
                    this.currentMarkers.push(marker)

                })
            },
            toggleEditTask () {
                this.editTaskDialog = !(this.editTaskDialog)
            },
            async fly () {
                if (this.selected && this.selected.longitude && this.selected.latitude) {
                    this.map.flyTo({
                        center: [this.selected.longitude, this.selected.latitude],
                        zoom: 13
                    })
                }
                else {
                    this.map.flyTo({
                        center: this.coordinates,
                        zoom: 10
                    })
                }
                this.map.resize()
            },
            async openDetail () {
                await this.toggleEditTask()
                await this.toggleDetailsTask()

            },
            toggleDetailsTask () {
                if(this.detailsTaskDialog){
                    if(this.selected.status === 'Complete' || this.selected.status === 'Delayed'){
                        this.clearSelectedTask()
                    }
                }
                this.detailsTaskDialog = !(this.detailsTaskDialog)
            },
        },
        watch: {
            mapTaskLocations () {
                this.addMarkers()
            },
            selected () {
                this.addMarkers()
                this.fly()
            },
            async clickCounter () {
                await mapHelpers.sleep(500).then(() => this.clickCounter = 0)
            },
        },
        computed: {
            ...mapGetters({
                mapTaskLocations: 'jobTasks/workerMapTaskLocations',
                selected: 'jobTasks/selectedJobTask'
            }),
            mapTaskArray () {
                if(Array.isArray(this.mapTaskLocations)) {
                    return this.mapTaskLocations
                } else {
                    return [this.mapTaskLocations]
                }
            }
        }
    }
</script>
<style>
    .map-container-height{
        height: 100%;
    }
    .mapboxgl-ctrl-top-right .mapboxgl-ctrl {
        margin: 14px 12px 0 0 !important;
    }
    .mapboxgl-canvas {
        height: 100% !important;
    }
    .mapboxgl-marker:hover {
        cursor: pointer;
    }
</style>
